export enum WaterlyLocale {
  enUS = "en-US",
  esES = "es-ES",
}

export type LocaleNamespaceName = string;
export type LocaleNamespace = Record<string, string>;
